import React from 'react';
import { clearData } from '../helper';
import { WizardContext } from 'react-albus';

interface Props {
  wizard: WizardContext;
  isFirstStep?: boolean;
}

const Header: React.FC<Props> = ({ isFirstStep = false, wizard: { replace } }) => {
  return (
    <header>
      {!isFirstStep && (
        <button
          className="startover"
          type="button"
          onClick={() => {
            clearData();
            replace('Age');
          }}
        >
          <i className="fa fa-sync-alt" />
          <span>Start Over</span>
        </button>
      )}
      <a
        href="https://orionadvisortech.com"
        className="logo"
        target="_blank"
        rel="noreferrer noopener"
      />
    </header>
  );
};

export default Header;
